import { get } from "lodash";
import React from "react";
import "./gaugeBar.scss";
import { numberFormatters } from "common";
import { NumberFormatKind } from "common/types";
const colorSet = {
    blueVariation: "blue-variation-color-chart",
    default: "default-color-chart",
    dualGreenRed: "dual-green-red-color-chart",
    esg: "esg-color-chart",
    greenBlueVariation: "green-blue-variation-color-chart",
    orangeVariation: "orange-variation-color-chart",
    purpleVariation: "purple-variation-color-chart"
};
export const getMaxGaugeColumnValue = (api, field) => {
    const rowData = [];
    api.forEachNode((node) => rowData.push(node.data));
    const colName = field;
    if (colName) {
        const allNumbers = rowData.map((row) => get(row, colName)).filter((item) => item);
        return Math.max(...allNumbers);
    }
    return 0;
};
const getBarLength = (value, maxValue) => {
    let barLength = "0%";
    if (maxValue > 0 && value && !isNaN(value)) {
        barLength = numberFormatters(value / maxValue, NumberFormatKind.percent);
    }
    return barLength;
};
export const GaugeCellRenderer = (props) => {
    let { value } = props;
    if (props.valueFormatted) {
        value = props.valueFormatted;
    }
    const maxValue = getMaxGaugeColumnValue(props.api, props.colDef?.field);
    const isPercentageValue = typeof value === "string" && value.search("%") !== -1;
    const barLength = getBarLength(props.value, isPercentageValue ? 1 : maxValue);
    if (isNaN(props.value)) {
        value = null;
    }
    const selectedColor = props.colorHue ? props.colorHue : 0;
    return React.createElement("span", { className: "gauge-bar" },
        React.createElement("span", { className: "gauge-bar-text", style: props.minTextWidth ? { minWidth: props.minTextWidth } : {} }, value),
        React.createElement("span", { className: `gauge-bar-container ${props.colorSet ? colorSet[props.colorSet] : colorSet.default}` },
            React.createElement("span", { className: `gauge-bar-bar gauge-bar-bar-color-${selectedColor}`, style: { width: `${barLength}` } })));
};
